module.exports = __webpack_public_path__ + "static/media/litho_1.1feef65e.jpg";